export default __webpack_public_path__ + "static/media/sass.67875c40.png";